import { isText } from '../utils/bits'
import { includes } from 'lodash-es'
import { signUserFunction } from './gallery-properties.flow'

export default signUserFunction(calcLocaleDir)

function calcLocaleDir(rawVal, calcProp) {
  if (isText(rawVal)) {
    return rawVal
  }

  const locale = calcProp('locale')
  const locale_dir = includes(['ar', 'he', 'fa'], locale) ? 'rtl' : 'ltr'
  return locale_dir
}
